import { render, staticRenderFns } from "./AILogicInputOutput.vue?vue&type=template&id=20ea8ecf&scoped=true"
import script from "./AILogicInputOutput.vue?vue&type=script&lang=js"
export * from "./AILogicInputOutput.vue?vue&type=script&lang=js"
import style0 from "./AILogicInputOutput.vue?vue&type=style&index=0&id=20ea8ecf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ea8ecf",
  null
  
)

export default component.exports